module.exports = __webpack_public_path__ + "img/category-note.b249ef35.png";